import { Grid } from "@mui/material";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useTranslation } from "react-i18next";
import usePackageList from "hooks/usePackageList";

const PackageList = () => {
  const { t } = useTranslation();

  const { isLoggedIn, isSubmitting, packages, userRecords, _onPurchase, _onUploadPaymentProof, _onCancelPurchase } = usePackageList();

  return (
    <>
      {packages?.map((item: any, index: number) => {
        const currentRecord = userRecords?.find((record: any) => record?.package_id === item?.organization_package_id);

        return (
          <div
            key={index}
            className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <div className="flex-1 p-5 flex space-x-4">
              <Grid container justifyContent="center" alignItems="center">
                <Grid item md={12} sm={12}>
                  <div className="flex flex-col items-center justify-center">
                    <h3 className="text-2xl font-semibold" style={{ color: "#6366F1" }}>
                      {item?.package_name}
                    </h3>
                    <span className="mt-1.5 text-lg ">{item?.package_description}</span>
                    <h1 className="mt-1.5 text-xl font-semibold">HKD ${item?.price}</h1>
                    <br></br>
                    <span className="mt-1.5 text-sm text-neutral-400">{t("packages_items")} :</span>
                    <span className="mt-1.5 text-sm text-neutral-400">{item?.membership}</span>
                    <span className="mt-1.5 text-sm text-neutral-400">{Number(item?.point) == 0 ? null : item?.point}</span>
                    {item?.vouchers?.map((voucher: any) => (
                      <span className="mt-1.5 text-sm text-neutral-400">
                        {voucher?.quantity} x {voucher?.voucher_name}
                      </span>
                    ))}
                    <br></br>
                    <span className="mt-1.5 text-sm text-neutral-400">{item?.period}</span>
                    <br></br>

                    {isLoggedIn && (
                      <>
                        {userRecords?.length > 0 && currentRecord ? (
                          <>
                            {!currentRecord?.["payment_proof_url"] ? (
                              <ButtonSecondary loading={isSubmitting} disabled={isSubmitting}>
                                <input
                                  type="file"
                                  className="absolute inset-0 opacity-0 cursor-pointer"
                                  onChange={(e: any) => {
                                    _onUploadPaymentProof(e, currentRecord?.["organization_package_user_record_id"]);
                                  }}
                                  accept="image/png, image/jpeg"
                                  multiple={false}
                                />
                                <i className="text-xl las la-file-invoice"></i>
                                <span className="ml-3"> {t("packages_upload_proof")}</span>
                              </ButtonSecondary>
                            ) : (
                              <ButtonSecondary disabled>
                                <i className="text-xl las la-check"></i>
                                <span className="ml-3"> {t("packages_proof_uploaded")}</span>
                              </ButtonSecondary>
                            )}
                            <ButtonSecondary className="mt-3" onClick={() => _onCancelPurchase(currentRecord?.["organization_package_user_record_id"])}>
                              <span> {t("packages_cancel")}</span>
                            </ButtonSecondary>
                          </>
                        ) : (
                          <ButtonSecondary loading={isSubmitting} disabled={isSubmitting} onClick={() => _onPurchase(item?.organization_package_id)}>
                            <i className="text-xl las la-shopping-bag"></i>
                            <span className="ml-3"> {t("packages_purchase")}</span>
                          </ButtonSecondary>
                        )}
                      </>
                    )}
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PackageList;
